var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.selectedTab.type == _vm.ItemCategoryTypes.PART ||
    _vm.selectedViewType != _vm.viewTypes.tabbedView
      ? _c(
          "div",
          { staticClass: "mb-5" },
          [
            _c("quote-builder-part-headings-component", {
              attrs: {
                name: _vm.partCategoryObject?.displayName || "Parts",
                count: _vm.partLength,
                "total-amount": _vm.partsTotal,
                "is-full-width": _vm.isFullWidth,
              },
            }),
            _c(
              "div",
              { staticClass: "rows" },
              [
                _c(
                  "draggable",
                  _vm._b(
                    {
                      attrs: {
                        clone: ($event) =>
                          _vm.cloneHandler($event, _vm.ItemCategoryTypes.PART),
                        group: {
                          name: _vm.ItemCategoryTypes.PART,
                          pull: "clone",
                          put: true,
                        },
                        handle: ".item-drag-handle",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.itemMoved(
                            $event,
                            _vm.ItemCategoryTypes.PART
                          )
                        },
                        over: function ($event) {
                          $event.preventDefault()
                        },
                        enter: function ($event) {
                          $event.preventDefault()
                        },
                      },
                      model: {
                        value: _vm.innerValue.parts,
                        callback: function ($$v) {
                          _vm.$set(_vm.innerValue, "parts", $$v)
                        },
                        expression: "innerValue.parts",
                      },
                    },
                    "draggable",
                    {
                      disabled: !_vm.isRowDraggable,
                      ghostClass: "draggable-ghost",
                      dragClass: "draggable-drag",
                    },
                    false
                  ),
                  _vm._l(_vm.innerValue.parts, function (item) {
                    return _c("quote-builder-part-component-item", {
                      key: item.quoteItemId,
                      attrs: {
                        "inner-value": _vm.innerValue,
                        "is-full-width": _vm.isFullWidth,
                        "items-assessments": _vm.itemsAssessments,
                        item: item,
                        "read-only-view": _vm.readOnlyView,
                        "is-selected": _vm.editItemObj.id === item.quoteItemId,
                        vehicle: _vm.vehicle,
                        "labour-type": _vm.innerValue.labourType,
                        "sub-quote-no": _vm.innerValue.subQuoteNo,
                        "quoting-method": _vm.innerValue.quotingMethod,
                        "show-assessment":
                          (_vm.innerValue.quoteAssessments?.length || 0) > 0,
                        "next-supplemetry-no": _vm.nextSupplemetryNo,
                        "orm-object": _vm.ormObject,
                        "next-line-number": _vm.nextLineNumber,
                        "is-editable": !_vm.readOnlyComputed,
                      },
                      on: {
                        deleteItem: _vm.deleteItem,
                        goToPartsCheck: _vm.goToPartsCheck,
                        focusNextRow: function ($event) {
                          return _vm.$emit("focusNextRow", item)
                        },
                        handlePresentAs: (itemId) =>
                          _vm.$emit("handlePresentAs", itemId),
                        itemRowClicked: (value, event, close) =>
                          _vm.$emit("handleItemRowClick", value, event, close),
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "button is-outlined is-primary",
                  attrs: { disabled: _vm.readOnlyComputed },
                  on: {
                    click: function ($event) {
                      return _vm.addBlankItem()
                    },
                  },
                },
                [_vm._v(" + Add Item ")]
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }